import React, { useEffect } from 'react';
import { CULQI_CHECKOUT_LINK, KEY_PUBLIC_CULQI } from '../../infrastructure/appConstants';
import { Button } from 'semantic-ui-react';

const CulqiBtn = ({title, amount, currency, event}) => {

    useEffect(() => {
        const script = document.createElement('script');
        script.src = CULQI_CHECKOUT_LINK;
        script.async = true;
        document.body.appendChild(script);

        script.onload = () => {

            const CulqiCheckout = window.CulqiCheckout;

            const settings = {
                title,
                currency,
                amount,
            };

            const paymentMethods = {
                tarjeta: true,
                yape: true,
                billetera: true,
                bancaMovil: true,
                agente: true,
                cuotealo: true,
            };

            const options = {
                lang: 'auto',
                installments: true,
                modal: true,
                paymentMethods,
                paymentMethodsSort: Object.keys(paymentMethods),
            };

            const handleCulqiAction = async () => {
                
                if (Culqi.token) {
                    await event(Culqi.token);
                }

                Culqi.close();

            };

            const config = {
                settings,
                options,
            };

            const Culqi = new CulqiCheckout(KEY_PUBLIC_CULQI, config);

            Culqi.culqi = handleCulqiAction;

            window.openCulqi = () => {
                Culqi.open();
            };
        };

        return () => {
            document.body.removeChild(script);
        };
    }, []);

    return (
        <Button
            content="Confirmar"
            fluid
            onClick={() => { window.openCulqi() }}
            color="yellow"
            size="large"
        />
    );
};

export default CulqiBtn;